export default __webpack_public_path__ + "static/media/0067.f399aa1b.png";